<template>
  <el-form label-position="left" label-width="0px"
           class="demo-ruleForm login-container">
    <h2 class="title">消防安全管理承诺书</h2>
    <span style="font-size:18px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我是{{organization.name}}（单位名称）的消防安全责任人，按照《中华人民共和国消防法》、《消防安全责任制实施办法》，为有效预防火灾事故发生，现就我单位消防安全工作作出以下几项承诺：（勾选）
      </span>
    <br>

    <el-form-item style="width:100%;">
      <el-checkbox-group v-model="checkedAgreeTypes" @change="handleCheckedAgreesChange">
        <el-checkbox  style="margin-left:30px;width:700px" v-for="dictAgreeType in dictAgreeTypes" :label="dictAgreeType.value" :key="dictAgreeType.value">{{dictAgreeType.name}}</el-checkbox>
      </el-checkbox-group>
   </el-form-item>

    <el-form-item style="width:100%;text-align:center;">
      <el-button type="primary" style="width:40%;" @click.native.prevent="handleAgree" :loading="loading">同意
        </el-button>
      <el-button type="warning" style="width:40%;" @click.native.prevent="handleDisAgree" :loading="loading">拒绝
        </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import API from "../api/api_user";
  import LOGIN_API from "../api/api_login";
  import DICAPI from "../api/api_dict";


  export default {
    data() {
      return {
        loading: false,
        dictAgreeTypes: [],
        checkedAgreeTypes:[],
        orgid:"",
        organization:{
          name:""
        }

      };
    },
    mounted: function () {//页面初始化方法
      var data= JSON.parse(localStorage.getItem('access-user'));
      console.log(data);
      this.organization = data.organization;
      this.orgid = data.organization.id;
      let  params = "";
      let that = this;
  
      DICAPI.dictAgreeType(params).then(function (result) {
        console.log(result);
        if (result && result.code == 200) {
          that.dictAgreeTypes = result.data;
        }
      }, function (err) {
      }).catch(function (error) {
        console.log(error);
      });
    },
    methods: {
      handleCheckedAgreesChange(value){
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.dictAgreeTypes.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.dictAgreeTypes.length;
      },
      handleDisAgree(){
        this.$router.push({path: "/login"});
      },
      handleAgree() {
        let that = this;
        if(that.checkedAgreeTypes.length==0){
          alert("请至少勾选一个");
          return;
        }

   
  
        this.loading = true;
       let para = {
        orgId: this.orgid,
        agreeTypes: that.checkedAgreeTypes.toString()
       };
        LOGIN_API.agree(para)
          .then(
            function (result) {
              console.log(result)
              that.loading = false;
              if (result && result.code == 200) {
                console.log(result);
                that.$router.push({path: "/"});
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.msg || "登录失败",
                  duration: 2000
                });
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
          
     
      }
    }
  };
</script>
<style>
  body {
    background: #dfe9fb;
  }
</style>
<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 160px auto;
    width: 800px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    background: -ms-linear-gradient(top, #ace, #00c1de); /* IE 10 */
    background: -moz-linear-gradient(top, #ace, #00c1de); /*火狐*/
    background: -webkit-gradient(
        linear,
        0% 0%,
        0% 100%,
        from(#ace),
        to(#00c1de)
    ); /*谷歌*/
    background: -webkit-linear-gradient(
        top,
        #ace,
        #00c1de
    ); /*Safari5.1 Chrome 10+*/
    background: -o-linear-gradient(top, #ace, #00c1de); /*Opera 11.10+*/

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// Agree.vue?21288f16